import { combineReducers } from 'redux';
import * as types from '@components/auth/constants';

const initialState = window.__INITIAL_STATE__;

export default combineReducers({
    user(state = initialState.user, action) {
        switch (action.type) {
            case types.LOGIN_ATTEMPT_SUCCESS:
            case types.USER_CONTEXT_SUCCESS:
                return { ...state, ...action?.user || {} };
            default:
                return state;
        }
    },
    permissions(state = initialState.permissions, action) {
        switch (action.type) {
            case types.LOGIN_ATTEMPT_SUCCESS:
            case types.USER_CONTEXT_SUCCESS:
                return { ...state, ...action?.permissions || {} };
            default:
                return state;
        }
    },
    company(state = initialState.company, action) {
        switch (action.type) {
            case types.LOGIN_ATTEMPT_SUCCESS:
            case types.USER_CONTEXT_SUCCESS:
                return { ...state, ...action?.company || {} };
            default:
                return state;
        }
    },
    modules(state = initialState.modules, action) {
        switch (action.type) {
            case types.LOGIN_ATTEMPT_SUCCESS:
            case types.USER_CONTEXT_SUCCESS:
                return { ...state, ...action?.modules || {} };
            default:
                return state;
        }
    },
    statuses(state = initialState.statuses || [], action) {
        switch (action.type) {
            case types.LOGIN_ATTEMPT_SUCCESS:
            case types.USER_CONTEXT_SUCCESS:
                return [ ...action?.statuses || [] ];
                // return [ ...state, ...action.statuses ];
            default:
                return state;
        }
    },
    featureFlags(state = initialState.featureFlags || {}, action) {
        switch (action.type) {
            case types.LOGIN_ATTEMPT_SUCCESS:
            case types.USER_CONTEXT_SUCCESS:
                return { ...action?.featureFlags || {} };
            default:
                return state;
        }
    },
    modals(state = initialState.modals || [], action) {
        switch (action.type) {
            case types.LOGIN_ATTEMPT_SUCCESS:
            case types.USER_CONTEXT_SUCCESS:
                return [ ...action?.modals || [] ];
            default:
                return state;
        }
    },
});
